// extracted by mini-css-extract-plugin
export default {"text":"Text_text__61vnz"};